import { Create } from 'react-admin'

import VoiceActorForm from './VoiceActorForm'

const VoiceActorCreate = props => (
  <Create redirect="list" {...props}>
    <VoiceActorForm />
  </Create>
)

export default VoiceActorCreate
